import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { urls } from "../configs/serviceConfig";
import { authorizationHeaders } from "./authorizationHeaders";
import { ProfileViewModelV3 } from "../types/ProfileViewModel";
import { UserServiceEligibility } from "../types/userServiceEligibility";

interface VerifyOtpRequest {
  email: string;
  otp: string;
}

interface VerifyOtpResponse {
  isValid: boolean;
}

export const profileApiV3 = createApi({
  reducerPath: "profileApiV3",
  baseQuery: fetchBaseQuery({
    baseUrl: `${urls.profileService}/v3`,
    prepareHeaders: authorizationHeaders,
  }),

  endpoints: (builder) => ({
    getProfileById: builder.query<ProfileViewModelV3, string>({
      query: (profileId) => {
        return `/profile/${profileId}`;
      },
    }),

    getProfileServiceEligibilityCheck: builder.query<UserServiceEligibility, { userId: string, referringServiceCode: string, programmeId: string }>({
      query: ({ userId, referringServiceCode, programmeId }) => {
        return `profile/${userId}/check-service-eligibility/${referringServiceCode}/${programmeId}`;
      },
    }),

    requestOtp: builder.mutation<void, string>({
      query(email) {
        return {
          url: `/otp`,
          method: "POST",
          body: {
            email: email,
          },
        };
      },
    }),
    verifyOtp: builder.mutation<VerifyOtpResponse, VerifyOtpRequest>({
      query(data) {
        return {
          url: `/otp/${data.otp}`,
          method: "POST",
          body: {
            email: data.email,
            otp: data.otp,
          },
        };
      },
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetProfileByIdQuery,
  useGetProfileServiceEligibilityCheckQuery,
  useRequestOtpMutation,
  useVerifyOtpMutation,
} = profileApiV3;
